// extracted by mini-css-extract-plugin
module.exports = {"container":"CarComparisonCard_container__Sd6yO","addIcon":"CarComparisonCard_addIcon__1sLYq","BtnSkeleton":"CarComparisonCard_BtnSkeleton__E-LrH"};